import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from "mobx";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import classnames from "classnames";
import TopFilterToolbarSort from "@components/Navigation/TopFilterToolbarSort";
import Breadcrumb from "@components/Navigation/Breadcrumb";

@inject("store")
@observer
export default class BerikssonTopFilterToolbar extends React.Component {

    constructor(props) {
        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.state = {open: false};
        this.handleFacetChanged = this.handleFacetChanged.bind(this);
        this.handleOpened = this.handleOpened.bind(this);
        this.accordionCallback = this.accordionCallback.bind(this);
        this.navigateToCategory = this.navigateToCategory.bind(this);
        this.openOptions = this.openOptions.bind(this);
        this.closeOptions = this.closeOptions.bind(this);
        this.clearAllFacets = this.clearAllFacets.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.clearFreeText = this.clearFreeText.bind(this);


        this.state = {
            openedFacets: [],
            showOptions: null,
            containerClass: "",
            transition: false
        }
    }

    navigateToSiteUrl(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.navigateToSiteUrl(navigation.mainTree, node.Url, node.Name);
    }

    openOptions(e, name) {
        e.stopPropagation();
        e.preventDefault();
        let newValue = name;
        if (name === this.state.showOptions) {
            newValue = null;
        }

        this.setState({showOptions: newValue});
    }

    closeOptions() {
        this.setState({showOptions: null});
    }

    navigateToCategory(e, url) {

        e.preventDefault();
        const navigation = this.props.store.navigation;

        navigation.updateLocationFromFacets(url);
    }

    handleFacetChanged(e, facetName, facetOptionValue) {
        e.stopPropagation();
        e.preventDefault();
        const navigation = this.props.store.navigation;
        this.handleOpened(facetName);
        navigation.toggleFacetOption(facetName, facetOptionValue);
    }

    clearAllFacets() {
        const navigation = this.props.store.navigation;
        navigation.updateLocationWithoutFacets();//.clearAll();
    }

    clearFreeText() {
        const navigation = this.props.store.navigation;
        navigation.clearFreeText();
    }


    handleOpened(facetName) {
        var facet1 = this.state.openedFacets.length > 0 ? this.state.openedFacets.find((f) => {
            return f === facetName
        }) : null;

        if (!facet1) {
            this.state.openedFacets.push(facetName);
        }
    }

    accordionCallback(facetName, state) {
        var facet1 = this.state.openedFacets.length > 0 ? this.state.openedFacets.find((f) => {
            return f === facetName
        }) : null;
        if (!facet1 && state === 0) {
            this.state.openedFacets.push(facetName);
        } else if (facet1 && state === -1) {
            this.state.openedFacets.pop(facetName);
        }

        if (this.props.callback) {
            this.props.callback();
        }
    }

    renderCategoryCount(category, categoryIdsFacet) {
        const navigation = this.props.store.navigation;
        const categoryId = category.CategoryIds[0];
        if (!categoryIdsFacet) return null;

        const facetValue = categoryIdsFacet.FacetValues.find(x => x.Value === categoryId);
        if (!facetValue) {
            return (<span style={{color: "#aaa"}}>(0)</span>);
        }

        //console.log("categoryIdsFacet", categoryIdsFacet, facetValue);
        return (<span style={{color: "#aaa"}}>({facetValue.Hits})</span>

        );

    }

    renderLevel(node, categoryIdsFacet) {
        const navigation = this.props.store.navigation;
        const children = node.Children.filter(f => f.Alias === "icom_category" && f.Visible);
        return (children && children.length > 0 && <ul>
            {children.map(category => {

                const isActive = navigation.NodeIsActive(category.Id);
                //console.log("isActive:", category.Id, isActive, category.Name);

                return (<li key={category.Id} className={isActive ? "active" : ""}><a href=""
                                                                                      onClick={(e) => this.navigateToCategory(e, category.Url)}>
                    {category.Name}</a> {/*this.renderCategoryCount(category, categoryIdsFacet)*/}
                    {isActive && this.renderLevel(category, categoryIdsFacet)}
                </li>);
            })}
        </ul>);
    }

    closeOptions(event) {
        if (event.target === this.refs.facetOptionsClose) {
            this.setState({
                showOptions: null
            });
        }
    }

    handleScroll(event) {
        if (this.state.transition || typeof window === 'undefined') {
            return;
        }

        let scrollClass = window.scrollY > 0 ? "minimized" : "";
        let that = this;

        if (scrollClass !== this.state.containerClass) {
            this.setState({
                containerClass: scrollClass,
                transition: true
            });
            setTimeout(function () {
                that.setState({
                    transition: false
                });
                if (that.props.handleMinimized) {
                    that.props.handleMinimized();
                }
            }, 200);
        }
    }

    componentDidMount() {
        window.addEventListener("click", this.closeOptions);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.closeOptions);
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {

        const navigation = this.props.store.navigation;

        const clearAllFacets = this.props.store.navigation.facets.filter(fi => fi.Name !== "SubCategories").some(f => f.FacetValues.some(fv => fv.Selected)) &&
            <li key={"ft-all"} onClick={() => this.clearAllFacets()}>
                <button className="facet-title"><FontAwesomeIcon icon={
                    ["fas", "times"]} className={"toggle"} size="1x"/> {this.props
                        .store.navigation.dictionary.clearAllFacets ||
                    "Rensa alla"}</button>
            </li>;

        const freeTextQuery = this.props.store.navigation.getFreetextFromLocation() &&
            <li key={"ft-freeText"} onClick={() => this.clearFreeText()}>
                <button className="facet-title">{this.props
                        .store.navigation.dictionary.freeText ||
                    "Sökord: "} {this.props.store.navigation.getFreetextFromLocation()} <FontAwesomeIcon icon={
                    ["fas", "times"]} className={"toggle"} size="1x"/></button>
            </li>;


        const activeFacets = this.props.store.navigation.facets.map(facet => {
            if (facet.Name === "CategoryIds" || facet.Name === "SubCategories") {
                return;
            }

            return facet.FacetValues.filter(x => x.Selected).map(selectedFacet => {


                return (<li key={"ft-" + selectedFacet.Value}
                            onClick={(e) => this.handleFacetChanged(e, facet.Name, selectedFacet.Value)}><a href="#"
                                                                                                            className="facet-title"><FontAwesomeIcon
                    icon={
                        ["fas", "times"]} className={"toggle"} size="1x"/> {selectedFacet.Value}</a></li>);
            });
        });

        return (
            <div className={"row " + this.state.containerClass}>

                <div className="product-grid-container p-0">
                    <ul className="top-filter-toolbar-selected-facets">
                        <li className="top-filter-breadcrumbs">
                            <Breadcrumb />
                        </li>
                        {this.props.headerName && <li>
                            {navigation.isProductModalOpen
                                ? <h3 className="top-filter-header">{this.props.headerName}</h3>
                                : <h1 className="top-filter-header">{this.props.headerName}</h1>}
                        </li>}
                        {activeFacets}

                        {freeTextQuery}


                        {clearAllFacets}

                        <li className="filter-dropdown-sort">
                            <TopFilterToolbarSort/>
                        </li>
                    </ul>
                </div>
            </div>);
    }
}


